export const DEFAULT_EMPLOYEE_PERMISSIONS = {
  tabs: {
    dashboard: true,
    restroLiteShops: true,
    restroLiteLeads: false,
  },
  actions: {
    addShop: true,
    editShop: true,
    extendSubscription: false,
    forceLogoutShop: false,
    deleteShop: false,
    editPaymentLink: false,
  },
};

export function normalizeEmployeePermissions(input) {
  const base = JSON.parse(JSON.stringify(DEFAULT_EMPLOYEE_PERMISSIONS));
  if (!input || typeof input !== 'object') return base;
  if (input.tabs) {
    Object.keys(base.tabs).forEach((k) => {
      if (typeof input.tabs[k] === 'boolean') base.tabs[k] = input.tabs[k];
    });
  }
  if (input.actions) {
    Object.keys(base.actions).forEach((k) => {
      if (typeof input.actions[k] === 'boolean') base.actions[k] = input.actions[k];
    });
  }
  return base;
}
